import React from 'react';
import { motion } from 'framer-motion';
import { BotanicalDivider } from './Decorative';
import { useLanguage } from '../i18n/LanguageContext';
export function TalleresIntro() {
  const {
    t
  } = useLanguage();
  return <section className="bg-cream py-16 md:py-24 px-6" data-id="element-797">
      <div className="max-w-3xl mx-auto text-center" data-id="element-798">
        <BotanicalDivider data-id="element-799" />
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-lg md:text-xl text-forest-dark/80 leading-relaxed mt-12" style={{
        fontFamily: 'Montserrat, sans-serif'
      }} data-id="element-800">
          {t('talleres_intro')}
        </motion.p>
      </div>
    </section>;
}